export default __webpack_public_path__ + "static/media/Shadowed Valleys-26.472c14e1.jpg";